var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('bankingInstitutionsListComponent')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }